<template functional>
  <div
    v-bind="data.attrs"
    class="footer-address"
  >

    <h2 class="footer-address__heading">Kontakt</h2>

    <address class="footer-address__contact">
      <p class="footer-address__paragraph">
        Claussen-Simon-Stiftung<br>
        Große Elbstraße 145f<br>
        22767 Hamburg
      </p>
      <p class="footer-address__paragraph">
        <a
          class="footer-address__link"
          href="tel:+494038037150"
        >
          Tel.: +49 (0) 40 38 03 71 5-0
        </a><br>
        <a
          class="footer-address__link"
          href="mailto:info@claussen-simon-stiftung.de"
        >
          info@claussen-simon-stiftung.de
        </a>
      </p>
    </address>

  </div>
</template>

<script>
export default {
  name: 'AFooterAddress'
}
</script>

<style scoped>
.footer-address__heading {
  margin: 0;

  font-size: 1em;
  color: var(--color-brand);
}

@media (min-width: 800px) {
  .footer-address__contact {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: var(--grid-spacing);
  }
}

.footer-address__paragraph {
  margin: 0;
}

.footer-address__link {
  text-decoration: none;
  color: inherit;
}

.footer-address__link:hover {
  text-decoration: underline;
}
</style>
